module.exports = __webpack_public_path__ + "static/media/loading.a5f6d1ec.svg";